import { container } from '@intelingu/core/IoC/container';
import { ILocalStorageAdapter, LocalStorageSymbol } from '@intelingu/core/stores/adapters/ILocalStorageAdapter';
import { AchievementApi } from '@intelingu/core/api/AchievementApi';
import { CardApi } from '@intelingu/core/api/CardApi';
import { CourseApi } from '@intelingu/core/api/CourseApi';
import { ProgressApi } from '@intelingu/core/api/ProgressApi';
import { SubscriptionsApi } from '@intelingu/core/api/SubscriptionsApi';
import { UserApi } from '@intelingu/core/api/UserApi';
import { HttpClient } from '@intelingu/core/configs/axios.config';
import { LocalStorageAdapter } from '../stores/adapters/LocalStorageAdapter';
import { AppStore } from '../stores/AppStore';
import { ExerciseCardStore } from '@intelingu/core/stores/cards/ExerciseCardStore';
import { AnswersStore } from '@intelingu/core/stores/cards/AnswersStore';
import { ExplanationCardStore } from '@intelingu/core/stores/cards/ExplanationCardStore';
import { TopicCardStore } from '@intelingu/core/stores/cards/TopicCardStore';
import { VocabularyCardStore } from '@intelingu/core/stores/cards/VocabularyCardStore';
import { CardStore } from '@intelingu/core/stores/CardStore';
import { CourseStore } from '@intelingu/core/stores/CourseStore';
import { FormStore } from '@intelingu/core/stores/FormStore';
import { NotifyStore } from '../stores/NotifyStore';
import { SubscriptionStore } from '@intelingu/core/stores/SubscriptionStore';
import { UserStore } from '@intelingu/core/stores/UserStore';
import {CardSourceSymbol, ICardSourceAdapter} from "@intelingu/core/stores/adapters/ICardSourceAdapter";
import {IProgressSourceAdapter, ProgressSourceSymbol} from "@intelingu/core/stores/adapters/IProgressSourceAdapter";
import {BackendCardSourceAdapter} from "../stores/adapters/BackendCardSourceAdapter";
import {BackendProgressSourceAdapter} from "../stores/adapters/BackendProgressSourceAdapter";
import {BootstrapStore} from "../stores/BootstrapStore";
import {AuthStore} from "../stores/AuthStore";
import {AnalyticsStore} from "../stores/AnalyticsStore";
import {ISentryAdapter, SentrySymbol} from "@intelingu/core/stores/adapters/ISentryAdapter";
import {SentryAdapter} from "../stores/adapters/SentryAdapter";

container.bind<ISentryAdapter>(SentrySymbol).to(SentryAdapter).inSingletonScope();
container.bind<ILocalStorageAdapter>(LocalStorageSymbol).to(LocalStorageAdapter).inSingletonScope();
container.bind<ICardSourceAdapter>(CardSourceSymbol).to(BackendCardSourceAdapter).inSingletonScope();
container.bind<IProgressSourceAdapter>(ProgressSourceSymbol).to(BackendProgressSourceAdapter).inSingletonScope();
container.bind<HttpClient>(HttpClient).toSelf().inSingletonScope();
container.bind<AppStore>(AppStore).toSelf().inSingletonScope();
container.bind<CardStore>(CardStore).toSelf().inSingletonScope();
container.bind<VocabularyCardStore>(VocabularyCardStore).toSelf().inSingletonScope();
container.bind<AnswersStore>(AnswersStore).toSelf().inRequestScope();
container.bind<ExerciseCardStore>(ExerciseCardStore).toSelf().inSingletonScope();
container.bind<ExplanationCardStore>(ExplanationCardStore).toSelf().inSingletonScope();
container.bind<TopicCardStore>(TopicCardStore).toSelf().inSingletonScope();
container.bind<UserStore>(UserStore).toSelf().inSingletonScope();
container.bind<FormStore>(FormStore).toSelf().inRequestScope();
container.bind<CourseStore>(CourseStore).toSelf().inSingletonScope();
container.bind<NotifyStore>(NotifyStore).toSelf().inSingletonScope();
container.bind<AuthStore>(AuthStore).toSelf().inSingletonScope();
container.bind<BootstrapStore>(BootstrapStore).toSelf().inSingletonScope();
container.bind<AnalyticsStore>(AnalyticsStore).toSelf().inSingletonScope();

container.bind<CardApi>(CardApi).toSelf().inSingletonScope();
container.bind<CourseApi>(CourseApi).toSelf().inSingletonScope();
container.bind<UserApi>(UserApi).toSelf().inSingletonScope();
container.bind<ProgressApi>(ProgressApi).toSelf().inSingletonScope();
container.bind<AchievementApi>(AchievementApi).toSelf().inSingletonScope();
container.bind<SubscriptionStore>(SubscriptionStore).toSelf().inSingletonScope();
container.bind<SubscriptionsApi>(SubscriptionsApi).toSelf().inSingletonScope();
